import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: 2rem;
  margin: 2rem 0;

  & > {
    flex-basis: auto;
  }
`;

export { Container };
